export interface IFeatureFlags {
    getFeatureFlag: (flagName: string) => boolean;
}

export function featureFlags({
    featureFlags,
}: {
    featureFlags: Record<string, boolean>;
}): IFeatureFlags {
    const featureFlagCache = { ...featureFlags };
    return {
        getFeatureFlag: (flagName: string): boolean => {
            return featureFlagCache?.[flagName] || false;
        },
    };
}
